// Authorization HOC

import React from 'react'
import {connect} from 'react-redux'
import NotAuthorized from '../components/NotAuthorized'

import {
  _isOnlyStaff
} from '../helpers/userRoles'

const Authorization = (allowedRoles) => {
  return (WrappedComponent) => {
    class WithAuthorization extends React.Component {

      _checkAuthorization() {
        let {currentUser, match} = this.props
        let userRoles = currentUser.roles || []
        let authorized = allowedRoles.some(r=> userRoles.includes(r))

        // more authorization rules
        if(_isOnlyStaff(this.props.currentUser) && match.params.userId && (match.params.userId != this.props.currentUser.id) ) { authorized=false }

        return authorized
      }

      render() {
        let authorized = this._checkAuthorization()

        if(authorized) {
          return <WrappedComponent {...this.props} />
        } else {
          return <NotAuthorized />
        }
      }
    }

    const mapStateToProps = (state) => ({
      currentUser: state.reduxTokenAuth.currentUser.attributes
    })

    return connect(mapStateToProps, null)(WithAuthorization)
  }
}

export default Authorization;


// WEBPACK FOOTER //
// ./src/shared/javascripts/hocs/Authorization.jsx